@if (navigationItems?.length > 0) {
  <section class="sh-dashboard-content-template__row" aria-describedby="fast-links">
    <h2 id="fast-links" class="sh-page-title--section sh-icon-title">
      <svg class="sh-icon-title__icon" sh-icon name="external-link" aria-hidden="true" [size]="IconSize.LARGE"></svg>
      {{ title }}
    </h2>
    <div class="sh-content-columns -sh-condense">
      <div class="sh-content-columns__column -sh-column-33">
        <div class="sh-dashboard-content-template__row__item">
          <sh-dashboard-navigation [title]="subtitle" [navigationLinks]="navigationItems"></sh-dashboard-navigation>
        </div>
      </div>
    </div>
  </section>
}
